/* unplugin-vue-components disabled */import script from "./DownloadQrcode.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownloadQrcode.vue?vue&type=script&lang=ts&setup=true"

import "./DownloadQrcode.vue?vue&type=style&index=0&id=015d85f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-015d85f9"]])

export default __exports__